export const DEFAULT_LAT = 41.9028;
export const DEFAULT_LNG = 12.4964;
export const DEFAULT_ZOOM = 17;